import { useCallback } from 'react';

import { useFeature } from '@/hooks/useFeature';

import { HOMEPAGE_REVAMP } from '@/utils/featureFlags';
import { tokenPageRoute, tradeRoute, type TokenRef } from '@/utils/url';

/**
 * Resolves where a token click should land: the homepage trade module when the
 * revamp flag is on, the legacy token page otherwise.
 */
export const useTokenRoute = () => {
  const homepageRevamp = useFeature(HOMEPAGE_REVAMP);

  return useCallback(
    (token: TokenRef, options?: Parameters<typeof tradeRoute>[1]) =>
      homepageRevamp ? tradeRoute(token, options) : tokenPageRoute(token, options),
    [homepageRevamp],
  );
};
